var render = function render(){var _vm=this,_c=_vm._self._c;return _c('login-wrapper',[_c('div',{staticClass:"text-center"},[_c('h1',{staticClass:"py-3"},[_vm._v(" Error ")]),_c('p',[_vm._v("We were unable to find a Daybreak site at this URL.")]),_c('p',[_vm._v("Please check your link again or contact your system administrator.")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }